import useAuthHasUserClass from '@apps/www/src/www/hooks/useAuthHasUserClass';
import useUIState, { UIStateKeys } from '@apps/www/src/www/hooks/useUIState';
import SVKeyboardKey from '@pkgs/shared-client/components/SVKeyboardKey';
import useEventCallback from '@pkgs/shared-client/hooks/useEventCallback';
import UserClass from '@pkgs/shared/enums/UserClass';

function _Listener() {
	const [showModeratorControls, setShowModeratorControls] = useUIState(
		UIStateKeys.SHOW_MODERATOR_CONTROLS,
	);

	const handleTrigger = useEventCallback(() => {
		setShowModeratorControls(!showModeratorControls);
	});

	return <SVKeyboardKey keys={['d']} onTrigger={handleTrigger} />;
}

export default function SVModeratorControlsController() {
	const isModerator = useAuthHasUserClass(UserClass.MODERATOR);

	if (!isModerator) {
		return null;
	}

	return <_Listener />;
}
